import { useCallback } from 'react'

import { Box, FormControlLabel, Radio, RadioGroup } from '@material-ui/core'

import { getSegmentValue } from 'components/SegmentSelector/segment-service'

import { withContext } from '../Context'

export const SegmentName = 'LegalSex'

enum LegalSexType {
  Everyone = 'everyone',
  Female = 'female',
  Male = 'male',
}

type LegalSexSelectorProps = {
  criteria: string
  onChange: (criteria: string, segmentName: string, value: any, operation?: string) => void
  segment: object
}

export const LegalSexSelector = ({ criteria = 'Must', segment, onChange }: LegalSexSelectorProps) => {
  const currentValue = getSegmentValue(segment, criteria, SegmentName)
  const selected = currentValue.length > 0 ? currentValue[0] : LegalSexType.Everyone
  const change = useCallback(
    (values) => {
      onChange(criteria, SegmentName, values)
    },
    [criteria, onChange],
  )
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        pl={1}
      >
        <RadioGroup
          aria-label="Legal Sex"
          value={selected}
          onChange={(e) => {
            const selectedType = e.target.value
            const value = selectedType === LegalSexType.Everyone ? [] : [selectedType]
            change(value)
          }}
        >
          <FormControlLabel
            value={LegalSexType.Everyone}
            label="Everyone"
            control={<Radio color="primary" />}
          />
          <FormControlLabel
            value={LegalSexType.Female}
            label="Female"
            control={<Radio color="primary" />}
          />
          <FormControlLabel
            value={LegalSexType.Male}
            label="Male"
            control={<Radio color="primary" />}
          />
        </RadioGroup>
      </Box>
    </>
  )
}

export default withContext(LegalSexSelector)
